import { render, staticRenderFns } from "./editStudentinfoPage.vue?vue&type=template&id=b2b71510&"
import script from "./editStudentinfoPage.vue?vue&type=script&lang=js&"
export * from "./editStudentinfoPage.vue?vue&type=script&lang=js&"
import style0 from "./editStudentinfoPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports